document.addEventListener('DOMContentLoaded', function () {
  var nav = document.getElementById('panda-nav');
  var hamburger = document.getElementById('panda-nav-hamburger');
  var mobileDrawer = document.getElementById('panda-mobile-drawer');
  var mobileClose = document.getElementById('panda-mobile-close');
  var mobileOverlay = document.getElementById('panda-mobile-overlay');
  var searchBtn = document.getElementById('panda-search-btn');
  var searchOverlay = document.getElementById('panda-search-overlay');
  var searchClose = document.getElementById('panda-search-close');
  var searchBg = document.getElementById('panda-search-bg');
  var searchInput = document.getElementById('panda-search-input');

  function openMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.add('open');
    if (hamburger) hamburger.classList.add('open');
    document.body.classList.add('panda-nav-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.remove('open');
    if (hamburger) hamburger.classList.remove('open');
    document.body.classList.remove('panda-nav-open');
    document.body.style.overflow = '';
  }
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('open');
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 400);
  }
  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('open');
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      mobileDrawer.classList.contains('open') ? closeMobileDrawer() : openMobileDrawer();
    });
  }
  if (mobileClose) mobileClose.addEventListener('click', closeMobileDrawer);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileDrawer);
  document.querySelectorAll('.panda-mobile-nav-link, .panda-mobile-sub-link, .panda-mobile-cta').forEach(function (l) {
    l.addEventListener('click', closeMobileDrawer);
  });

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchBg) searchBg.addEventListener('click', closeSearch);

  document.querySelectorAll('.panda-search-tag').forEach(function (tag) {
    tag.addEventListener('click', function () {
      if (searchInput) searchInput.value = tag.dataset.term || '';
    });
  });

  document.querySelectorAll('.panda-mobile-sub-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var sub = btn.closest('.panda-mobile-nav-item').querySelector('.panda-mobile-sub');
      var isOpen = sub.classList.contains('open');
      document.querySelectorAll('.panda-mobile-sub').forEach(function (s) {
        s.classList.remove('open');
      });
      document.querySelectorAll('.panda-mobile-sub-toggle').forEach(function (b) {
        b.classList.remove('open');
      });
      if (!isOpen) {
        sub.classList.add('open');
        btn.classList.add('open');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileDrawer();
    }
  });

  if (nav) {
    window.addEventListener('scroll', function () {
      nav.style.borderBottomColor = window.scrollY > 80 ? 'rgba(192,19,3,.38)' : 'rgba(192,19,3,.18)';
    });
  }
});
